<template>
  <div class="Grid-layout Grid-card-restaurant" v-if="cards?.length">
    <ul :class="`Grid-card-restaurant__list ${colsClass}`">
      <li :id="`restaurant-card_${card.id}`" :key="card.id" class="Grid-card-restaurant__list-item" v-for="card in cards">
        <ux-molecules-card-restaurant v-bind="card" @card-restaurant::interact="cardEvent" />
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { type cardListType } from '~/components/ux/molecules/CardRestaurant/types';
import { gtmEvent } from '~/helpers/gtm';

export interface GridImagesProps {
  cards: cardListType | null;
  columns: 2 | 3 | 4 | null;
  pageName: null | string;
}

const props = withDefaults(defineProps<GridImagesProps>(), {
  cards: null,
  columns: 4,
  pageName: null
});

defineEmits(['grid-card-restaurant::interact']);

const colsClass = computed(() => {
  return props.columns ? `Grid-card-restaurant__list--${props.columns}cols` : '';
});

const cardEvent = (cardTitle: string) => {
  gtmEvent('bloc_interact', {
    bloc_interaction: `select - ${cardTitle.toLowerCase()}`,
    bloc_name: 'restaurant list',
    pagename: props.pageName
  });
};
</script>
<style lang="scss" scoped>
@use 'GridCardRestaurant';
</style>
